import React, { useState } from 'react'
import { connect } from 'react-redux'
import CSVReader from 'react-csv-reader'
import { handleUploadUserCSV, handleClearUpload } from '../../actions/reconciliationTypes'
import UploadAlert from './UploadAlert'
import './uploadstyle.css'
import { Button } from 'reactstrap'

const ReconProductItem = ({
  isAdmin,
  isSales,
  index,
  product,
  handleUploadUserCSV,
  handleClearUpload,
  reconSelected,
  loadingCSV,
  selectedCompany,
  isEssentialsSelected,
}) => {
  const handleFileUpload = (data, fileInfo) => {
    handleUploadUserCSV(reconSelected, product.id, data, index, selectedCompany.id, isEssentialsSelected)
  }

  const handleFileUploadError = () => {}
  const [rowOpen, setRowOpen] = useState(false)

  const parseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  }

  return (
    <React.Fragment>
      <tr key={index}>
        <td style={{ verticalAlign: 'middle' }}>{product.name}</td>
        <td style={{ verticalAlign: 'middle' }}>
          {product.users === null ? (
            <span style={{ color: 'red' }}>upload required</span>
          ) : (
            <span>
              {`${product.users.length} Users`}
              <Button style={{ float: 'right' }} color="primary" size="sm" onClick={() => setRowOpen(!rowOpen)}>
                {rowOpen ? 'Collapse' : 'Expand'}
              </Button>
            </span>
          )}
        </td>
        {loadingCSV[index] ? (
          <td style={{ verticalAlign: 'middle' }}>uploading...</td>
        ) : (
          <td>
            {product.users === null ? (
              <React.Fragment>
                {(isAdmin || isSales) && (
                  <CSVReader
                    parserOptions={parseOptions}
                    cssClass="react-csv-input"
                    onFileLoaded={handleFileUpload}
                    onError={handleFileUploadError}
                    inputId="UserUpload"
                  />
                )}
                {product.errorMessage && <span>Error uploading file, please try again</span>}
                {product.successMessage && <UploadAlert color="success">Uploaded successfully</UploadAlert>}
                {product.clearMessage && <UploadAlert color="primary">Upload Deleted</UploadAlert>}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {(isAdmin || isSales) && (
                  <CSVReader
                    parserOptions={parseOptions}
                    label="Re-upload data"
                    cssClass="react-csv-input"
                    onFileLoaded={handleFileUpload}
                    onError={handleFileUploadError}
                    inputId="UserUpload"
                  />
                )}
                {product.errorMessage && <span>Error uploading file, please try again</span>}
                {product.successMessage && <UploadAlert color="success">Uploaded successfully</UploadAlert>}
                {product.clearMessage && <UploadAlert color="primary">Upload Deleted</UploadAlert>}
              </React.Fragment>
            )}
          </td>
        )}
        {product.users === null ? (
          <td></td>
        ) : (
          <td>
            {(isAdmin || isSales) && (
              <Button color="danger" onClick={() => handleClearUpload(reconSelected, product.id, index)}>
                Delete Upload
              </Button>
            )}
          </td>
        )}
      </tr>
      {rowOpen && (
        <tr key={`$index-open`}>
          <td colSpan="5">
            {product && product.users && product.users.length > 0 ? (
              product.users.map((user, index) => <span style={{ display: 'inline-block', width: '33%' }}>{user}</span>)
            ) : (
              <span>no users found</span>
            )}
          </td>
        </tr>
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => ({
  loadingCSV: state.recon.loadingCSV,
  reconSelected: state.recon.reconSelected,
  selectedCompany: state.recon.selectedCompany,
  isEssentialsSelected: state.recon.isEssentialsSelected,
})

const mapDispatchToProps = {
  handleUploadUserCSV,
  handleClearUpload,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReconProductItem)
